import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Radio, Archive, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { IMG } from "@/lib/assets";

function Card({ c, archived = false }) {
  return (
    <Link
      to={`/campionati/${c.id}`}
      className={`block p-6 clip-hud transition-all hover:-translate-y-1 ${
        archived ? "panel panel-gold" : "cyber-panel"
      }`}
    >
      <div className="flex justify-between items-center mb-4">
        <span className={`font-rajdhani text-xs px-2 py-1 ${
          archived ? "bg-[var(--gold)] text-black" : "bg-[#10b981] text-black"
        }`}>
          {archived ? "ARCHIVIATO" : "● LIVE"}
        </span>
        <Trophy className={archived ? "text-[var(--gold)]" : "text-[#67e8f9]"} />
      </div>

      <h3 className={`heading text-3xl ${archived ? "gold-text" : "cyber-text"}`}>
        {c.name}
      </h3>

      <div className="mt-5 flex justify-end items-center gap-1 font-rajdhani text-sm text-[#67e8f9]">
        Visualizza Campionato <ChevronRight className="w-4 h-4" />
      </div>
    </Link>
  );
}

export default function PubCampionati() {
  const [data, setData] = useState({ active: [], archived: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/championships")
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="py-32 text-center text-gray-400">Caricamento...</div>;
  }

  return (
    <div className="text-white">
      <section className="relative py-24 text-center overflow-hidden">
        <div
          className="absolute inset-0"
          style={{ backgroundImage: `url(${IMG.cyberBg})`, backgroundSize: "cover" }}
        />
        <div className="absolute inset-0 bg-black/80" />
        <div className="relative">
          <h1 className="heading text-6xl sm:text-8xl">
            <span className="cyber-text">CAMPIO</span>
            <span className="gold-text">NATI</span>
          </h1>
          <p className="font-rajdhani text-gray-300 mt-4">
            Classifiche Clan e MVP dei Campionati SEALS
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 py-16 space-y-16">
        <section>
          <div className="flex items-center gap-3 mb-6">
            <Radio className="state-live" />
            <h2 className="heading text-4xl">Campionati <span className="state-live">Attivi</span></h2>
          </div>

          {data.active?.length ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {data.active.map(c => <Card key={c.id} c={c} />)}
            </div>
          ) : (
            <p className="text-gray-500 font-rajdhani">Nessun Campionato attivo.</p>
          )}
        </section>

        <section>
          <div className="flex items-center gap-3 mb-6">
            <Archive className="text-[var(--gold)]" />
            <h2 className="heading text-4xl">Campionati <span className="gold-text">Archiviati</span></h2>
          </div>

          {data.archived?.length ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {data.archived.map(c => <Card key={c.id} c={c} archived />)}
            </div>
          ) : (
            <p className="text-gray-500 font-rajdhani">Nessun Campionato archiviato.</p>
          )}
        </section>
      </div>
    </div>
  );
}
